// extracted by css-extract-rspack-plugin
var _1 = "lB48SN4xk8w5E8wU";
var _2 = "AwG6eb8oA080tbA0";
var _3 = "cKCsu6tpJKA20am4";
var _4 = "avZJnULQIc0dmldJ";
export { _1 as "assignedPlanApplied", _2 as "name", _3 as "taskHeader", _4 as "type" }
